import { locale, StorageCorePhoto, getClosestThumbnail, mapPhotoItem } from "@albelli/photoselector"
import { PhotoOrganiserItem } from "./Components/CategoryItemContainer"

export const mapPhoto = (photo: StorageCorePhoto): PhotoOrganiserItem => {
  const photoItem: PhotoOrganiserItem = Object.assign(mapPhotoItem(photo, "Photo Organizer"), { similarCount: photo.SimilarImages })
  return photoItem
}

export const mapCollection = (collection: any): PhotoOrganiserItem => {
  return {
    id: collection.CollectionId,
    dateTaken: new Date(Date.parse(collection.CoverPhoto.Date) || Date.now()),
    url: collection.CoverPhoto.Url,
    source: "Photo Organizer",
    urlThumbnail: getClosestThumbnail(collection.CoverPhoto.Thumbnails, 300),
    urlPreview: getClosestThumbnail(collection.CoverPhoto.Thumbnails, 1200),
    size: {
      width: collection.CoverPhoto.VisibleWidth,
      height: collection.CoverPhoto.VisibleHeight
    },
    name: collection.Name,
    imageCount: collection.MatchedPhotoCount
  }
}

export const mapEvent = (event: any): PhotoOrganiserItem => {
  return {
    id: event.EventId,
    dateTaken: new Date(Date.parse(event.CoverPhoto.Date) || Date.now()),
    url: event.CoverPhoto.Thumbnails[1].Url,
    source: "Photo Organizer",
    urlPreview: event.CoverPhoto.Thumbnails[0].Url,
    size: {
      width: event.CoverPhoto.VisibleWidth,
      height: event.CoverPhoto.VisibleHeight
    },
    name: event.Name,
    imageCount: event.MatchedPhotoCount,
    dateFrom: event.DateFrom
  }
}

export const mapYears = (response: any, title: string, photo: any): PhotoOrganiserItem => {
  return {
    id: title,
    dateTaken: new Date(Date.parse(photo.Date) || Date.now()),
    url: photo.Thumbnails[1].Url,
    source: "Photo Organizer",
    urlPreview: photo.Thumbnails[1].Url,
    size: {
      width: photo.VisibleWidth,
      height: photo.VisibleHeight
    },
    name: title,
    imageCount: response.MatchedPhotoCount
  }
}

export const mapMonths = (month: any) => {
  const months = locale.get().calender.months
  switch (month) {
    case 0:
      return locale.get().calender.allmonths
    case 1:
      return months.january
    case 2:
      return months.february
    case 3:
      return months.march
    case 4:
      return months.april
    case 5:
      return months.may
    case 6:
      return months.june
    case 7:
      return months.july
    case 8:
      return months.august
    case 9:
      return months.september
    case 10:
      return months.october
    case 11:
      return months.november
    case 12:
      return months.december
    default:
      return month
  }
}
